import React, { useState, useContext, useCallback } from "react";
import { withRouter, Redirect } from "react-router";
import { auth } from "../../services/firebase/Config";
import firebase from "firebase/app";
import { setUsuarioSesion } from "../../redux/sesion/sesionActions";
import {
  setUser,
  httpUserRequest,
  httpUserRequestSuccess,
} from "../../redux/usuario/usuarioActions";
import { useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import NuevoLogo from "../../img/slider/nuevoLogo.png";
import slider01 from "../../img/slider/img01.png";
import slider03 from "../../img/slider/img03.png";
import slider04 from "../../img/slider/app01.png";
import slider05 from "../../img/slider/app02.png";
import slider06 from "../../img/slider/app03.png";
import { fetchUser } from "../../services/firebase/usuarios";
import { getWizardConfig } from "../../services/firebase/wizardconfig"; // Importa la función
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useToasts } from "react-toast-notifications";
import { useForm } from "../../hooks/useForm";
import {
  LoginViewWrapper,
  FooterWrapper,
  LoginView,
  SectionForm,
  ImgLogo,
} from "./styles";
import { AuthContext } from "../../components/Auth.js";
import Carousel from "react-bootstrap/Carousel";

const Login = () => {
  const [, setUsuario] = useLocalStorage("usuario", {});
  const dispatch = useDispatch();
  const history = useHistory();
  const { addToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const [{ email, password }, handleInputChange] = useForm({
    email: "",
    password: "",
  });
  const { currentUser } = useContext(AuthContext);

  const handleLoginWithEmailAndPassword = (email, password) => {
    setIsLoading(true);
    auth
      .signInWithEmailAndPassword(email, password)
      .then((userCredentials) => {
        setIsLoading(false);
        history.push("/paciente");
      })
      .catch((err) => {
        auth.signOut();
        addToast(err.message, { appearance: "warning" });
        setIsLoading(false);
      });
  };

  const revisaConfiguracionConsultorio = useCallback(
    async (empresaId) => {
      if (!empresaId) return;
      const config = await getWizardConfig(empresaId);
      // Si no hay config o algún paso no está completado, redirige al wizard
      if (
        !config ||
        !Array.isArray(config.steps) ||
        config.steps.some((step) => !step.completed)
      ) {
        history.push("/admin/wizard-config");
        return false;
      }
      return true;
    },
    [history],
  );

  const verificaUsuario = useCallback(
    async (email, accessToken) => {
      dispatch(httpUserRequest());
      let usuario = await fetchUser(email);

      if (usuario.empresaId) {
        // If we don't have an accessToken (e.g. on refresh), get a fresh one from Firebase
        if (!accessToken && auth.currentUser) {
          accessToken = await auth.currentUser.getIdToken();
        }

        usuario.accessToken = accessToken;
        dispatch(httpUserRequestSuccess(usuario));
        dispatch(setUsuarioSesion(usuario));
        setUsuario(usuario);

        // Revisa configuración antes de redirigir
        const configurado = await revisaConfiguracionConsultorio(
          usuario.empresaId,
        );
        if (configurado) {
          history.push("/admin/dashboard/bienvenida");
        }
      } else {
        addToast(
          "No encontramos tu cuenta! Crea una cuenta para que puedas acceder.",
          { appearance: "error" },
        );
      }
    },
    [dispatch, setUsuario, addToast, history, revisaConfiguracionConsultorio],
  );

  const handleLoginWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();

    auth
      .signInWithPopup(provider)
      .then(async (login) => {
        const accessToken = await login.user.getIdToken();
        verificaUsuario(login.user.email, accessToken);
      })
      .catch((err) => {
        auth.signOut();
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLoginWithGoogle();
  };

  const renderLoginForm = () => {
    return !isLoading ? (
      <div className="form__container">
        <div className="img__container">
          <ImgLogo src={NuevoLogo} alt="Sysdent logo" />
          <p>Ingresa a tu cuenta</p>
        </div>
        <form onSubmit={handleSubmit}>
          <button className="form__button" type="submit">
            Ingresar con Google
          </button>
          <hr></hr>
          <div className="form__forgotpassword__container">
            <span>¿Aún no tienes una cuenta? </span>
            <Link to="/register" className="changeLink">
              CREAR CUENTA
            </Link>
          </div>
        </form>
      </div>
    ) : (
      <>
        <CircularProgress color="secondary" />
      </>
    );
  };

  React.useEffect(() => {
    if (currentUser) verificaUsuario(currentUser.email);
  }, [currentUser, verificaUsuario]);
  return (
    <LoginViewWrapper>
      <LoginView>
        <SectionForm>{renderLoginForm()}</SectionForm>
        <FooterWrapper>
          <Carousel variant="dark" className="carouselHeigth">
            <Carousel.Item>
              <img className="d-block w-100" src={slider01} alt="First slide" />
            </Carousel.Item>

            <Carousel.Item>
              <img className="d-block w-100" src={slider03} alt="Third slide" />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={slider04}
                alt="Fourth slide"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src={slider05} alt="Fifth slide" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src={slider06} alt="Sixth slide" />
            </Carousel.Item>
          </Carousel>
        </FooterWrapper>
      </LoginView>
    </LoginViewWrapper>
  );
};
export default withRouter(Login);
